var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cf-node-properties__input" },
    [
      _c("SearchableDropdown", {
        staticClass: "m-0 form__searchable-dropdown",
        attrs: {
          config: _vm.config,
          rules: _vm.rules,
          searchable: _vm.searchable,
          clearable: _vm.clearable
        },
        model: {
          value: _vm.selectValue,
          callback: function($$v) {
            _vm.selectValue = $$v
          },
          expression: "selectValue"
        }
      }),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("div", { staticClass: "cf-node-properties__input-error" }, [
            _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }